import './About.css';

function About() {
  return (
    <main className="about container">
      <header className="about-header animate-in delay-1">
        <div className="header-content">
          <div className="header-text">
            <h1>Bohdan Mahometa</h1>
            <p className="tagline">ML Engineer & Researcher</p>
          </div>
          <div className="header-photo">
            <img src="/photo.jpg" alt="Bohdan Mahometa" />
          </div>
        </div>
      </header>

      <section className="about-intro animate-in delay-2">
        <p>
          Machine learning engineer and researcher specializing in medical imaging, 
          structural biology, and LLM-based systems. My work spans deep learning
          for 3D volumes and multimodal data, protein structure prediction with 
          AlphaFold-based pipelines, and building production RAG and multi-agent systems.
        </p>
      </section>

      <section className="about-details animate-in delay-3">
        <div className="detail-block">
          <h3>Currently</h3>
          <ul className="position-list">
            <li>
              <span className="position-title">ML Engineer</span> at{' '}
              <a href="https://litslink.com/" target="_blank" rel="noopener noreferrer">LITSLINK</a>
              <span className="position-date">Jan 2025 – Present</span>
            </li>
            <li>
              <span className="position-title">ML Researcher</span> at{' '}
              <a href="https://abcgroup.cluspro.org/" target="_blank" rel="noopener noreferrer">Kozakov Lab, Stony Brook University</a>
              <span className="position-date">Jul 2023 – Present</span>
            </li>
          </ul>
        </div>

        <div className="detail-block">
          <h3>Education</h3>
          <p>
            <strong>Ukrainian Catholic University</strong><br />
            B.Sc. Computer Science, <em>cum laude</em><br />
            GPA: 93/100 · 2020–2024
          </p>
        </div>

        <div className="detail-block">
          <h3>Awards</h3>
          <ul className="awards-list">
            <li>
              <a href="https://www.kaggle.com/competitions/rsna-intracranial-aneurysm-detection/leaderboard" target="_blank" rel="noopener noreferrer">
                🥈 Silver Medal — RSNA Intracranial Aneurysm Detection
              </a>
              <span className="award-detail">Top 2.3%</span>
            </li>
            <li>
              <a href="https://algotester.com/bmlc" target="_blank" rel="noopener noreferrer">
                🥈 2nd Place — Bookmap ML Contest
              </a>
              <span className="award-detail">$2000 prize</span>
            </li>
            <li>
              <a href="https://www.kaggle.com/competitions/czii-cryo-et-object-identification/leaderboard" target="_blank" rel="noopener noreferrer">
                🥈 Silver Medal — CZII CryoET Object Identification
              </a>
              <span className="award-detail">Top 4.2%</span>
            </li>
            <li>
              <span>🏅 Kaggle Competitions Expert</span>
            </li>
          </ul>
        </div>

        <div className="detail-block">
          <h3>Focus Areas</h3>
          <ul className="interests-list">
            <li>Medical Imaging</li>
            <li>Protein Structure Prediction</li>
            <li>LLM Systems & RAG</li>
            <li>Computer Vision</li>
            <li>Deep Learning</li>
          </ul>
        </div>
      </section>

      <section className="about-connect animate-in delay-4">
        <h3>Connect</h3>
        <div className="connect-links">
          <a href="https://github.com/bogdanmagometa" target="_blank" rel="noopener noreferrer">
            GitHub
          </a>
          <span className="separator">/</span>
          <a href="https://www.linkedin.com/in/bohdanmahometa/" target="_blank" rel="noopener noreferrer">
            LinkedIn
          </a>
          <span className="separator">/</span>
          <a href="https://www.upwork.com/freelancers/~0129cbe6aa6bfe1a75" target="_blank" rel="noopener noreferrer">
            Upwork
          </a>
          <span className="separator">/</span>
          <a href="mailto:bogdan.magometa@gmail.com">
            Email
          </a>
        </div>
      </section>
    </main>
  );
}

export default About;
